module.exports = __webpack_public_path__ + "e918988edfc2f18e83d4b29aed0c3b4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-pirate-s.png
// module id = 1887
// module chunks = 0